<script setup>
import { MultipleLookupConfig } from '@pfsc/core/models/multiple-lookup-config';
import { lookupService } from '@pfsc/core/services/lookup.service';
import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import { CourseStatus } from '@pfsc/core/models/course-status';
import MultipleLookup from './multiple-lookup.vue';

defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['update:model-value']);

const config = new MultipleLookupConfig({
  title: globalTranslate('lookup.trainingStatuses'),
  fetch: lookupService.getCourseStatuses,
  toReadable: CourseStatus.toReadable,
});

</script>
<template>
  <multiple-lookup
    :model-value="modelValue"
    :config="config"
    :disabled="disabled"
    @update:model-value="emits('update:model-value', $event)"
  />
</template>
